import PropTypes from 'prop-types';

import { useAuth } from '../AuthContext';

function UnAuthenticated(props) {
  /**
   * Children components will be rendered when user is
   * not SSO authenticated and not backend authorized
   */

  const { children } = props;
  const auth = useAuth();

  if (!auth.isBackendAuthorized) {
    return children;
  }

  return null;
}

UnAuthenticated.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UnAuthenticated;
